import { http } from '@/http/axios.js'

// 管理员列表
export function getPosBindPageAPI(params) {
  return http({
    url: `/api/admin/lkl/active-data/page`,
    method: 'get',
    params
  })
}

export function importPosBindApi(data) {
  return http({
    url: `/api/admin/lkl/active-data/import`,
    method: 'post',
    data
  })
}



export function getPosServiceFeePageAPI(params) {
  return http({
    url: `/api/admin/lkl/transaction-fee-d0/page`,
    method: 'get',
    params
  })
}

export function importServiceFeeApi(data) {
  return http({
    url: `/api/admin/lkl/transaction-fee-d0/import`,
    method: 'post',
    data
  })
}



export function getPosWithdrawPageAPI(params) {
  return http({
    url: `/api/admin/lkl/transactions/page`,
    method: 'get',
    params
  })
}


export function getPosSimYearFeePageApi(params) {
  return http({
    url: `/api/admin/lkl/sim-year-fee/page`,
    method: 'get',
    params
  })
}


export function importSimYearFeeApi(data) {
  return http({
    url: `/api/admin/lkl/sim-year-fee/import`,
    method: 'post',
    data
  })
}
